import { useState } from "react";
import { PropertiesProps } from "../utils/useProperties";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  setEditOpen?: React.Dispatch<React.SetStateAction<boolean>>
  property?: PropertiesProps
}

interface details {
  propertyId?: string,
  propertyName: string,
  description: string,
  category: string,
  type: string,
  location: string,
  price: string,
  bedrooms: string,
  bathrooms: string,
  sqft: string,
  featured: boolean,
  sold: boolean,
  propertyImg?: string[],
}

const AddPropertyModal = ({ isOpen, setIsOpen, setEditOpen, property }: Props) => {

  const [files, setFiles] = useState<File[]>([])



  const [properties, setProperties] = useState<details>({
    propertyId: property ? property.id : '',
    propertyName: property ? property.name : '',
    description: property ? property.description : '',
    category: property ? property.category : '',
    type: property ? property.type : '',
    location: property ? property.location : '',
    price: property ? property.price : '',
    bedrooms: property ? property.bed : '',
    bathrooms: property ? property.bath : '',
    sqft: property ? property.sqft : '',
    featured: property ? (property.featured === 'true' ? true : false) : false,
    sold: property ? (property.sold === 'true' ? true : false) : false,
    propertyImg: property ? property.imgs : [],
  })


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    files.forEach((file) => formData.append("files[]", file));
    Object.keys(properties).forEach((key) => {
      const value = (properties as any)[key];
      formData.append(key, value);
    });

    formData.forEach((value, key) => {
      console.log(key, value);
    });

    const link = property ? "https://akjodem.com/editProperty.php" : "https://akjodem.com/uploadproperty.php"

    try {
      const response = await fetch(link, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.status === "success") {
        alert("Property uploaded successfully!");
        setFiles([]);
        setProperties({
          propertyName: "",
          description: "",
          category: "",
          type: "",
          location: "",
          price: "",
          bedrooms: "",
          bathrooms: "",
          sqft: "",
          featured: false,
          sold: false,
        });
      } else {
        alert(data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error uploading property.");
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = event.target;

    const newValue =
      type === "checkbox" && event.target instanceof HTMLInputElement
        ? event.target.checked
        : value;

    setProperties(prev => ({
      ...prev,
      [name]: newValue
    }));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.currentTarget.files;
    if (files) {
      const fileArray = Array.from(files);
      setFiles(fileArray);
    }
  };

  const handleClose = () => {
    setEditOpen?.(false)
    setIsOpen(false)
    window.location.reload()
  }


  return (
    <>

      {/* Modal */}

      <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-75">
        <div className="relative bg-white shadow-md p-6 rounded-lg w-full max-w-lg max-h-[90%] overflow-y-auto">
          <h2 className="mb-6 font-semibold text-gray-800 text-2xl">Add Property</h2>

          <button
            onClick={() => handleClose()}
            className="top-2 right-2 absolute text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Property Name</label>
              <input
                type="text"
                name="propertyName"
                value={properties.propertyName}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Description</label>
              <textarea
                name='description'
                value={properties.description}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Property Category</label>
              <select
                name="category"
                value={properties.category}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              >
                <option value="">Select Category</option>
                <option value="Property">Property</option>
                <option value="Land">Land</option>
                <option value="Rental">Rental</option>
                <option value="Shortlets">Shortlets</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Property Type</label>
              <select
                name="category"
                value={properties.type}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              >
                <option value="">Select Type</option>
                <option value="duplex">Duplex</option>
                <option value="terrace">Terrace</option>
                <option value="bungalow">Bungalow</option>
                <option value="apartment">Apartment</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Location</label>
              <input
                type="text"
                name="location"
                value={properties.location}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Price</label>
              <input
                name="price"
                type="number"
                value={properties.price}
                onChange={handleChange}
                required
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Bedrooms</label>
              <input
                name="bedrooms"
                type="number"
                value={properties.bedrooms}
                onChange={handleChange}
                required
                min="0"
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Bathrooms</label>
              <input
                name="bathrooms"
                type="number"
                value={properties.bathrooms}
                onChange={handleChange}
                required
                min="0"
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium text-gray-700 text-sm">sqft</label>
              <input
                name="sqft"
                type="number"
                value={properties.sqft}
                onChange={handleChange}
                required
                min="0"
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="flex items-center mb-4">
              <input
                id="featured"
                name="featured"
                type="checkbox"
                checked={Boolean(properties.featured)}
                onChange={handleChange}
                className="border-gray-300 rounded focus:ring-blue-500 w-4 h-4 text-blue-600"
              />
              <label htmlFor="featured" className="ml-2 text-gray-700 text-sm">Featured</label>
            </div>

            <div className="flex items-center mb-4">
              <input
                id="sold"
                name="sold"
                type="checkbox"
                checked={Boolean(properties.sold)}
                onChange={handleChange}
                className="border-gray-300 rounded focus:ring-blue-500 w-4 h-4 text-blue-600"
              />
              <label htmlFor="sold" className="ml-2 text-gray-700 text-sm">Sold</label>
            </div>

            <div className="mb-6">
              <label className="block mb-2 font-medium text-gray-700 text-sm">Upload Images</label>
              <input
                type="file"
                multiple
                onChange={(event) => handleFileChange(event)}
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>

            {property && property.imgs ?
              <>
                <p className="-mt-4 mb-3 text-red-800">If you don't want to replace the below images do not upload images(choose files)</p>
                <div className="grid grid-cols-3 mb-3">
                  {property.imgs.map((file, index) => (
                    <img src={`https://akjodem.com/${file}`} className="object-cover" />
                  ))}
                </div>
              </> : null

            }

            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg w-full text-white transition-colors"
            >
              Add Property
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default AddPropertyModal;

